// CRM-LEADS-2026-10-16 §4: the CRM as an installed app -- Android Chrome "Install app" / "Add to Home screen", and install
// on desktop Chrome or Edge. It opens full-screen, with no browser bar (manifest.webmanifest, display: standalone).
//   * The browser offers install once (beforeinstallprompt); we keep that offer so the Settings button can use it.
//   * Signed in for 30 days on a device that has signed in (lib: deviceSessionExpired); a new device signs in as before.

let deferredPrompt = null;
const listeners = new Set();
export function initInstall(win = typeof window !== 'undefined' ? window : null) {
  if (!win || !win.addEventListener) return;
  win.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); deferredPrompt = e; listeners.forEach((f) => f(true)); });
  win.addEventListener('appinstalled', () => { deferredPrompt = null; listeners.forEach((f) => f(false)); });
}
export const canInstall = () => !!deferredPrompt;
export function onInstallable(f) { listeners.add(f); return () => listeners.delete(f); }
/** Show the browser's own install dialog. -> 'accepted' | 'dismissed' | 'unavailable' */
export async function promptInstall() {
  if (!deferredPrompt) return 'unavailable';
  const e = deferredPrompt;
  deferredPrompt = null;
  e.prompt();
  const choice = await e.userChoice.catch(() => ({ outcome: 'dismissed' }));
  listeners.forEach((f) => f(false));
  return choice && choice.outcome === 'accepted' ? 'accepted' : 'dismissed';
}
/** Running as the installed app (not in a browser tab)? */
export function isStandalone(win = typeof window !== 'undefined' ? window : null) {
  if (!win) return false;
  try { if (win.matchMedia && win.matchMedia('(display-mode: standalone)').matches) return true; } catch { /* old browser */ }
  return !!(win.navigator && win.navigator.standalone);
}

/** Register the service worker (production builds; the dev server has none). */
export function registerServiceWorker(nav = typeof navigator !== 'undefined' ? navigator : null, env = process.env.NODE_ENV) {
  if (!nav || !nav.serviceWorker || env !== 'production') return Promise.resolve(null);
  return nav.serviceWorker.register('/sw.js').catch(() => null);
}

// ---- 30 days on a device that has signed in
export const DEVICE_KEY = 'crm.device.signedInAt';
export const DEVICE_DAYS = 30;
export function markDeviceSignIn(storage, now = Date.now()) {
  try { if (storage && !storage.getItem(DEVICE_KEY)) storage.setItem(DEVICE_KEY, String(now)); } catch { /* private window */ }
}
export function clearDeviceSignIn(storage) { try { if (storage) storage.removeItem(DEVICE_KEY); } catch { /* ignore */ } }
/** The device's sign-in is older than 30 days: sign in again. (No record = not expired; it is stamped on first sight.) */
export function deviceSessionExpired(storage, now = Date.now()) {
  let at = NaN;
  try { at = Number(storage && storage.getItem(DEVICE_KEY)); } catch { at = NaN; }
  return Number.isFinite(at) && at > 0 && now - at > DEVICE_DAYS * 864e5;
}
